import { useEffect, useState } from "react";
import { UserRound } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Field } from "@/components/common";
import { maskCep, maskPhone } from "@/lib/api";
import { EMPTY_ADDR } from "@/lib/boy";

export const EMPTY_CUSTOMER = { name: "", whatsapp: "", save: true };

export function CustomerBox({ bx, value, onChange, onAddress }) {
  const [list, setList] = useState([]);
  useEffect(() => {
    bx.get("/customers").then((r) => setList(r.data)).catch(() => {});
  }, [bx]);
  const set = (p) => onChange({ ...value, ...p });
  const pick = (id) => {
    const c = list.find((x) => x.id === id);
    if (!c) return;
    onChange({ ...value, name: c.name, whatsapp: maskPhone(c.whatsapp) });
    if (c.address?.street) onAddress({ ...EMPTY_ADDR, ...c.address, cep: maskCep(c.address.cep || "") });
  };
  return (
    <div className="space-y-3 rounded-xl border p-4" data-testid="boy-customer-box">
      <div className="flex items-start gap-2">
        <UserRound className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
        <div>
          <p className="text-sm font-semibold">Cliente (opcional)</p>
          <p className="text-xs text-muted-foreground">Com o WhatsApp do cliente, ele recebe o link para acompanhar o entregador no mapa e o aviso quando estiver chegando.</p>
        </div>
      </div>
      {!!list.length && (
        <Select onValueChange={pick}>
          <SelectTrigger data-testid="boy-customer-select"><SelectValue placeholder={`Escolher um dos meus clientes (${list.length})`} /></SelectTrigger>
          <SelectContent>{list.map((c) => <SelectItem key={c.id} value={c.id} data-testid={`boy-customer-option-${c.id}`}>{c.name || "Sem nome"} · {maskPhone(c.whatsapp)}</SelectItem>)}</SelectContent>
        </Select>
      )}
      <div className="grid gap-3 sm:grid-cols-2">
        <Field label="Nome do cliente"><Input value={value.name} onChange={(e) => set({ name: e.target.value })} data-testid="boy-customer-name-input" /></Field>
        <Field label="WhatsApp do cliente"><Input value={value.whatsapp} onChange={(e) => set({ whatsapp: maskPhone(e.target.value) })} inputMode="tel" placeholder="(00) 00000-0000" data-testid="boy-customer-whatsapp-input" /></Field>
      </div>
      <label className="flex items-center gap-2 text-sm">
        <Checkbox checked={value.save} onCheckedChange={(v) => set({ save: !!v })} data-testid="boy-customer-save" />Salvar na minha lista de clientes (com o endereço de entrega)
      </label>
    </div>
  );
}
